import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const Warning: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <path d="M7 0c3.87 0 7 3.13 7 7s-3.13 7-7 7-7-3.13-7-7 3.13-7 7-7zm0 9.61a.889.889 0 100 1.778.889.889 0 000-1.778zm0-6.99a.743.743 0 00-.743.743v4.49a.743.743 0 101.486 0v-4.49A.743.743 0 007 2.62z" />
  </Icon>
);
